import { createStyles, makeStyles } from '@material-ui/core';
import { DESKTOP_MAX_WIDTH } from 'src/utils/helpers/theme';

const useBlogStyles = makeStyles(() =>
    createStyles({
        root: {
            overflow: 'hidden'
        },
        mainContainer: {
            // paddingBottom: theme.spacing(10)
        },

        row: {
            maxWidth: DESKTOP_MAX_WIDTH,
            position: 'relative'
        }
    })
);

export default useBlogStyles;
